import { componentFactory } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-primary-loader.styles.scss?module';

export default componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'JtnUiPrimaryLoader',
  render() {
    const attributes = {
      attrs: this.$attrs,
      on: this.$listeners
    };

    return (
      <div class={styles.primaryLoader} {...attributes}>
        <div class={[styles.item, styles.itemFirst]} />
        <div class={[styles.item, styles.itemSecond]} />
        <div class={[styles.item, styles.itemThird]} />
        <div class={[styles.item, styles.itemFourth]} />
      </div>
    );
  }
});
